import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { ConnectionSettings } from '../schemas/connection-settings.schema';

/**
 * Sets the company connection settings
 * @returns a data object indicating success
 */
export function postCompanyConnectionSettings(
  this: unknown,
  connectionSettings: ConnectionSettings
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).companyConnectionSettingsUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(connectionSettings),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
      })
    )
  );
}
